import moment from 'moment'
import SESSIONS from '../constants/sessions'
import { FormatBase64, DecodeBase64 } from './'

const appName = process.env.VUE_APP_NAME.toLowerCase()
const cookiesDomain = process.env.VUE_APP_COOKIES

const getCookiesName = (customeName = '') => {
  let result = appName
  if (SESSIONS.IS_REFACTOR_STAGING) result = '___' + result
  if (SESSIONS.IS_REFACTOR_PROD) result = '__' + result
  if (SESSIONS.IS_PRODUCTION) result = '_' + result

  if (customeName?.length) result += '_' + customeName

  return result !== appName ? result : null
}

const removeHttpFromUrl = (url) => {
  const result = url
    ?.replaceAll('https://', '')
    ?.replaceAll('http://', '')
    ?.replaceAll('/', '')
  return result
}

const setCookie = ({ name, value = '', days = 1, domain = null }) => {
  if (domain === null || !name?.length) return

  const domainConf = 'domain=' + domain + ';'

  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  const cookies = `${name}=${value}; expires=${expires.toUTCString()}; path=/; secure; ${domainConf}`

  console.log('===> [COOKIES] setCookie', {
    cookies,
    domainConf,
    name,
  })

  document.cookie = cookies
}

const DeleteCookieLogedIn = () => setCookie({ name: getCookiesName() })
const DeleteCookieType = () =>
  setCookie({ name: getCookiesName('emtrade_type') })
const DeleteCookieGuide = () => setCookie({ name: getCookiesName('guide') })

const LogedInInformation = (params) => {
  const token = params?.token ?? ''
  const tokenArr = token.split('.')
  const tokenKey = moment().valueOf()
  const data = { [tokenKey]: tokenArr }

  setCookie({
    name: getCookiesName(),
    value: JSON.stringify(data),
    days: 1,
    domain: cookiesDomain,
  })
}

const EnvType = () => {
  setCookie({
    name: 'emtrade_type',
    value: process.env.VUE_APP_ENV_TYPE,
    days: 1,
    domain: cookiesDomain,
  })
}

const GetGuideInformation = () => {
  const cookiesName = getCookiesName('guide')
  const cookies = document.cookie
    ?.split(';')
    ?.map((item) => item.trim())
    ?.filter((item) => item.startsWith(cookiesName + '='))
    ?.map((item) => item.split('=')[1])

  if (cookies[0]) {
    const result = JSON.parse(DecodeBase64(cookies[0]))
    return result
  }

  return null
}

const GuideInformation = (params = null) => {
  const data = JSON.stringify(params)
  const cookiesName = getCookiesName('guide')

  setCookie({
    name: cookiesName,
    value: FormatBase64(data),
    days: 36500,
    domain: cookiesDomain,
  })
}

const Cookies = {
  EnvType,
  LogedInInformation,
  GuideInformation,
  GetGuideInformation,
  DeleteCookieLogedIn,
  DeleteCookieGuide,
  DeleteCookieType,
}

export default Cookies
